export default {
    xlarge: 24,
    large: 20,
    medium: 16, // default
    small: 14,
    xsmall: 12
};
